<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xxl="8" :xl="12" :lg="12" :md="14" :sm="24">
            <a-form-item label="预警时间">
              <a-range-picker show-time format="YYYY-MM-DD HH:mm:ss" @change="getNewDate" style="margin-right: 2%" />
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="异常单号">
              <a-input placeholder="请输入访问省" v-model="queryParam.docCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="异常单号2">
              <a-input placeholder="请输入访问市" v-model="queryParam.refCode"></a-input>
            </a-form-item>
          </a-col>

          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset1" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('区域访问花色统计表')">导出</a-button> -->
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{ fixed: true, selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleCheck(record)">查看</a>
        </span>
      </a-table>
    </div>
    <monitorListModal ref="modalForm" @ok="modalFormOk" />
  </a-card>
</template>

<script>
// 公方法
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import monitorListModal from './monitorListModal'
import moment from 'moment'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
// import { goldStoneJpglistsVisitLogGetCount } from '@/api/api'

import { getAction } from '@/api/manage'

export default {
  name: 'monitorList',
  mixins: [JeecgListMixin],
  components: {
    monitorListModal,
    JDictSelectTag,
  },
  data() {
    return {
      description: '金牌石浏览记录表管理页面',
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          },
        },
        {
          title: '监控序号',
          align: 'center',
          dataIndex: 'controlId',
        },
        {
          title: '预警等级',
          align: 'center',
          dataIndex: 'controlLevel',
        },
        // {
        //   title: '监控点位',
        //   align: 'center',
        //   dataIndex: '',
        // },
        // {
        //   title: '负责人',
        //   align: 'center',
        //   dataIndex: '',
        // },
        {
          title: '异常单号',
          align: 'center',
          dataIndex: 'docCode',
        },
        {
          title: '异常单号2',
          align: 'center',
          dataIndex: 'refCode',
        },
        {
          title: '其他描述',
          align: 'center',
          dataIndex: 'hdText',
        },
        {
          title: '执行时间',
          align: 'center',
          dataIndex: 'insertTime',
        },
        {
          title: '已推送',
          align: 'center',
          dataIndex: 'status',
        },
        {
          title: '处理人',
          align: 'center',
          dataIndex: 'dealName',
        },
        {
          title: '处理时间',
          align: 'center',
          dataIndex: 'dealTime',
        },
        // {
        //   title: '处理描述',
        //   align: 'center',
        //   dataIndex: '',
        // },
        // {
        //   title: '审核人',
        //   align: 'center',
        //   dataIndex: '',
        // },
        // {
        //   title: '审核时间',
        //   align: 'center',
        //   dataIndex: '',
        // },
        // {
        //   title: '审核结果',
        //   align: 'center',
        //   dataIndex: '',
        // },
        // {
        //   title: '对应推送id',
        //   align: 'center',
        //   dataIndex: '',
        // },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list: '/erp/supervisory/list',
        delete: '/goldenstone.base/goldStoneJpglistsVisitLog/delete',
        deleteBatch: '/goldenstone.base/goldStoneJpglistsVisitLog/deleteBatch',
        // exportXlsUrl: '/goldenstone.base/goldStoneJpglistsVisitLog/exportXlsArea',
        // importExcelUrl: 'goldenstone.base/goldStoneJpglistsVisitLog/importExcel',
      },
      dictOptions: {},
      disableMixinCreated: true,
      totalsAllPage: 0,
      sourceData: [],
    }
  },

  mounted() {
    this.loadData(1);
  },

  methods: {
    getCurrentPageData(currentPageData) {
      if (currentPageData.length == 0) {
        return 0
      } else if (currentPageData.length == 1) {
        return currentPageData[0].flowerColorVisitCount
      } else {
        return currentPageData.reduce((total, item, index) => {
          console.log(index)
          if (index == 1) {
            return parseInt(item.flowerColorVisitCount) + parseInt(total.flowerColorVisitCount)
          } else {
            return parseInt(item.flowerColorVisitCount) + total
          }
        })
      }
    },

    //日期组件
    moment,

    getNewDate(dates, dateStrings) {
      this.queryParam.startTime = dateStrings[0]
      this.queryParam.endTime = dateStrings[1]
    },

    handleCheck: function (record) {
      this.$refs.modalForm.edit(record)
    },

    searchReset1() {
      for (let key in this.queryParam) {
        this.queryParam[key] = ''
      }
      this.loadData(1)
    },

    handleChooseFirst() {
      this.searchQuery()
    },
  },
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.table-footer-div {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
}
.footer-p-left {
  flex-grow: 7;
}
.footer-p-right {
  margin-right: 10px;
}
.color-red {
  color: red;
}
</style>
